// ============================================================================
// Pharmacy First — Mock Data
// Single source of truth. UI components must use the getter functions at the
// bottom of this file, never the raw arrays, so scenario switching stays consistent.
// ============================================================================

// ---------------------------------------------------------------------------
// Lookups
// ---------------------------------------------------------------------------
// FIX #1: Masvingo is its own territory; every city maps to a geographically
// honest province, and every one of the 8 territories has >=1 city.
export const TERRITORIES = [
  "Harare", "Bulawayo", "Manicaland", "Mashonaland East",
  "Mashonaland West", "Matabeleland South", "Midlands", "Masvingo"
];

export const CITIES = [
  { city: "Harare", territory: "Harare" },
  { city: "Chitungwiza", territory: "Harare" },
  { city: "Bulawayo", territory: "Bulawayo" },
  { city: "Gwanda", territory: "Matabeleland South" },
  { city: "Mutare", territory: "Manicaland" },
  { city: "Rusape", territory: "Manicaland" },
  { city: "Marondera", territory: "Mashonaland East" },
  { city: "Ruwa", territory: "Mashonaland East" },
  { city: "Chinhoyi", territory: "Mashonaland West" },
  { city: "Kadoma", territory: "Mashonaland West" },
  { city: "Gweru", territory: "Midlands" },
  { city: "Kwekwe", territory: "Midlands" },
  { city: "Masvingo", territory: "Masvingo" },
  { city: "Zvishavane", territory: "Masvingo" }
];

export const SALES_EXECS = [
  { id: "SE-01", name: "Tendai Moyo", territory: "Harare" },
  { id: "SE-02", name: "Rutendo Chikafu", territory: "Bulawayo" },
  { id: "SE-03", name: "Farai Gumbo", territory: "Manicaland" },
  { id: "SE-04", name: "Chiedza Mutasa", territory: "Mashonaland East" },
  { id: "SE-05", name: "Tapiwa Ndlovu", territory: "Midlands" },
  { id: "SE-06", name: "Nyasha Dziva", territory: "Masvingo" },
  { id: "SE-07", name: "Kudzai Bere", territory: "Mashonaland West" },
  { id: "SE-08", name: "Simba Ncube", territory: "Matabeleland South" }
];

export const STAGES = [
  "Order Received", "Telecaller Validation", "Stock Allocation",
  "Warehouse Processing", "Dispatch Pending", "Dispatched",
  "Invoice Generated", "Delivered"
];

export const WAREHOUSES = ["Harare Central", "Bulawayo Depot", "Mutare Sub-depot"];

export const DELAY_REASON_CODES = [
  "Forex/Import Delay", "Manufacturing Delay", "Logistics/Transport Delay",
  "Demand Surge (Unplanned)", "Regulatory/Customs Hold"
];

const CLASSES = ["Platinum", "Gold", "Silver", "Bronze"];

// FIX #4: single source of truth for score->tier so classification is ALWAYS
// derived from score. Baseline and growth override both call this, so they can
// never disagree, and a growth score bump always produces the correct tier.
export function classifyPotential(score) {
  if (score > 80) return "Platinum";
  if (score > 65) return "Gold";
  if (score > 50) return "Silver";
  return "Bronze";
}

// ---------------------------------------------------------------------------
// Products (16 SKUs, 5 divisions)
// ---------------------------------------------------------------------------
export const PRODUCTS = [
  { sku: "HET-1001", productName: "Hetrocef 500", brandName: "Hetrocef", packSize: "10x10 Tablets", division: "Antibiotics", category: "Antibiotics", isPromoted: false, isDisrupted: true, basePrice: 8.50 },
  { sku: "HET-1002", productName: "Hetamox 250", brandName: "Hetamox", packSize: "10x6 Capsules", division: "Antibiotics", category: "Antibiotics", isPromoted: false, isDisrupted: false, basePrice: 6.20 },
  { sku: "HET-1003", productName: "Azithro-Het 500", brandName: "Azithro-Het", packSize: "3x1 Strip", division: "Antibiotics", category: "Antibiotics", isPromoted: false, isDisrupted: false, basePrice: 11.00 },
  { sku: "HET-2001", productName: "Cardiopril 10", brandName: "Cardiopril", packSize: "10x10 Tablets", division: "Cardiac", category: "Cardiac", isPromoted: true, isDisrupted: false, basePrice: 14.50 },
  { sku: "HET-2002", productName: "Betaloc-Het 50", brandName: "Betaloc-Het", packSize: "10x10 Tablets", division: "Cardiac", category: "Cardiac", isPromoted: false, isDisrupted: false, basePrice: 9.75 },
  { sku: "HET-2003", productName: "Atorstat 20", brandName: "Atorstat", packSize: "10x10 Tablets", division: "Cardiac", category: "Cardiac", isPromoted: false, isDisrupted: true, basePrice: 18.00 },
  { sku: "HET-3001", productName: "Glucomet 500", brandName: "Glucomet", packSize: "10x10 Tablets", division: "Diabetes", category: "Diabetes", isPromoted: false, isDisrupted: false, basePrice: 7.80 },
  { sku: "HET-3002", productName: "Insulet Mix 30/70", brandName: "Insulet", packSize: "1x10ml Vial", division: "Diabetes", category: "Diabetes", isPromoted: false, isDisrupted: true, basePrice: 22.00 },
  { sku: "HET-3003", productName: "Glimehet 2", brandName: "Glimehet", packSize: "10x10 Tablets", division: "Diabetes", category: "Diabetes", isPromoted: false, isDisrupted: false, basePrice: 6.50 },
  { sku: "HET-4001", productName: "Painex-Het 400", brandName: "Painex-Het", packSize: "10x10 Tablets", division: "Pain Management", category: "Pain Management", isPromoted: false, isDisrupted: false, basePrice: 4.20 },
  { sku: "HET-4002", productName: "Diclohet Gel", brandName: "Diclohet", packSize: "30g Tube", division: "Pain Management", category: "Pain Management", isPromoted: false, isDisrupted: false, basePrice: 5.60 },
  { sku: "HET-4003", productName: "Tramahet 50", brandName: "Tramahet", packSize: "10x10 Capsules", division: "Pain Management", category: "Pain Management", isPromoted: false, isDisrupted: true, basePrice: 9.90 },
  { sku: "HET-5001", productName: "Vitahet C 1000", brandName: "Vitahet", packSize: "10x10 Tablets", division: "Vitamins", category: "Vitamins", isPromoted: false, isDisrupted: false, basePrice: 3.50 },
  { sku: "HET-5002", productName: "Multihet Forte", brandName: "Multihet", packSize: "30 Tablets Bottle", division: "Vitamins", category: "Vitamins", isPromoted: false, isDisrupted: false, basePrice: 5.00 },
  { sku: "HET-5003", productName: "Calcihet D3", brandName: "Calcihet", packSize: "60 Tablets Bottle", division: "Vitamins", category: "Vitamins", isPromoted: false, isDisrupted: false, basePrice: 4.80 },
  { sku: "HET-5004", productName: "Ferrohet Plus", brandName: "Ferrohet", packSize: "30 Tablets Bottle", division: "Vitamins", category: "Vitamins", isPromoted: false, isDisrupted: false, basePrice: 6.10 }
];

const DISRUPTED_SKUS = PRODUCTS.filter(p => p.isDisrupted).map(p => p.sku);
const PROMOTED_SKU = "HET-2001";
const PRODUCT_BY_SKU = Object.fromEntries(PRODUCTS.map(p => [p.sku, p]));

// ---------------------------------------------------------------------------
// Pharmacies (22 records, 6 flagged growthCohort)
// ---------------------------------------------------------------------------
const PHARMACY_NAMES = [
  "Avondale Family Pharmacy", "CityCare Chemist", "Baines Avenue Pharmacy",
  "Mbare Community Pharmacy", "Borrowdale Health Pharmacy", "Highfield Pharmacy",
  "Northend Chemist Bulawayo", "Kumalo Pharmacy", "Robert Mugabe Rd Pharmacy",
  "Sakubva Pharmacy", "Dangamvura Chemist", "Ruwa Health Pharmacy",
  "Chinhoyi Central Pharmacy", "Kadoma Main Pharmacy", "Gwanda Chemist",
  "Mkoba Pharmacy", "Senga Pharmacy", "Masvingo City Pharmacy",
  "Rusape Pharmacy", "Chitungwiza Unit L Pharmacy", "Marondera Central Chemist",
  "Zvishavane Pharmacy"
];
const OWNER_NAMES = [
  "T. Chirwa","S. Ncube","P. Moyo","R. Sibanda","F. Chikwava","L. Mahachi",
  "N. Dube","B. Mabhena","K. Muponda","J. Chidziva","W. Mangwiro","E. Mafios",
  "C. Chitiyo","G. Nyoni","H. Mlotshwa","A. Chihoro","D. Mudzingwa","V. Mushayi",
  "M. Chirenje","I. Zulu","O. Mtisi","Y. Chirinda"
];

function seedRand(seed) {
  let s = seed;
  return () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
}
const rnd = seedRand(42);

// FIX #4: choose growth-cohort pharmacies whose BASELINE score leaves clear
// headroom for a visible tier jump (baseline Gold/Silver/Bronze, never Platinum),
// verified after generation below.
const GROWTH_COHORT_IDS = ["PH-Z-0002", "PH-Z-0006", "PH-Z-0009", "PH-Z-0013", "PH-Z-0017", "PH-Z-0021"];

export const PHARMACIES = PHARMACY_NAMES.map((name, i) => {
  const id = `PH-Z-${String(i + 1).padStart(4, "0")}`;
  const cityInfo = CITIES[i % CITIES.length];
  const cat = ["A", "B", "C"][Math.floor(rnd() * 3)];
  const isGrowth = GROWTH_COHORT_IDS.includes(id);
  // FIX #4: growth-cohort pharmacies get a baseline score capped below Platinum
  // threshold so the +18 bump always crosses at least one tier boundary.
  let potentialScore = 40 + Math.floor(rnd() * 55);
  if (isGrowth && potentialScore > 62) potentialScore = 48 + Math.floor(rnd() * 12); // 48-59 (Bronze/Silver)
  const dailyFootfall = 30 + Math.floor(rnd() * 120);
  const monthlyFootfall = dailyFootfall * 27;
  const exec = SALES_EXECS.find(e => e.territory === cityInfo.territory) || SALES_EXECS[0];

  const growthScore = Math.min(99, potentialScore + 22);

  // Phase 5: credit limit for the Order Booking credit-health check.
  // Deterministic by category + index — deliberately NOT rnd()-based, since
  // an extra rnd() call here would shift the PRNG sequence for every
  // subsequent generation step (orders, stock, POB), which several Phase
  // 2/4 fixes depend on landing at specific array indices.
  const CATEGORY_CREDIT_LIMIT = { A: 15000, B: 8000, C: 4000 };
  const creditLimit = CATEGORY_CREDIT_LIMIT[cat] + (i % 5) * 300;

  return {
    customerId: id,
    pharmacyName: name,
    ownerName: OWNER_NAMES[i],
    mobile1: `+263 7${1 + (i % 8)} ${String(1000000 + i * 137).slice(0, 3)} ${String(1000 + i * 91).slice(0, 4)}`,
    mobile2: i % 3 === 0 ? `+263 7${2 + (i % 7)} ${String(2000000 + i * 91).slice(0, 3)} ${String(3000 + i * 51).slice(0, 4)}` : null,
    email1: `${name.toLowerCase().replace(/[^a-z]+/g, ".")}@pharmzw.co.zw`,
    // BRD Module 1 mandates OTP verification on FOUR channels (Mobile 1,
    // Mobile 2, Email 1, Email 2). email2 was previously null on every
    // pharmacy, so the dual-OTP modal could only ever exercise two channels
    // and the compliance story couldn't actually be demonstrated. Secondary
    // contacts are paired — a pharmacy that registers a second phone
    // typically registers a second email too — so email2 follows the same
    // condition as mobile2 rather than being independently random.
    email2: i % 3 === 0 ? `accounts.${name.toLowerCase().replace(/[^a-z]+/g, ".")}@pharmzw.co.zw` : null,
    drugLicenseNo: `MCAZ-${1000 + i * 7}-2024`,
    address: `${12 + i} ${["Robert Mugabe Rd","Josiah Chinamano Ave","Herbert Chitepo St","Samora Machel Ave","Fife Ave"][i % 5]}`,
    city: cityInfo.city,
    province: cityInfo.territory,
    pincode: `${263000 + i * 11}`,
    territory: cityInfo.territory,
    assignedSalesExec: exec.name,
    dailyFootfall,
    monthlyFootfall,
    category: cat,
    creditLimit,
    potentialScore,
    potentialClassification: classifyPotential(potentialScore), // FIX #4: derived
    otpVerified: !(isGrowth && i % 2 === 0),
    growthCohort: isGrowth,
    scenarioOverrides: {
      growth: isGrowth ? {
        dailyFootfall: Math.round(dailyFootfall * 1.25),
        monthlyFootfall: Math.round(monthlyFootfall * 1.28),
        potentialScore: growthScore,
        potentialClassification: classifyPotential(growthScore), // FIX #4: derived from same fn
        otpVerified: true
      } : null
    }
  };
});

const PHARMACY_BY_ID = Object.fromEntries(PHARMACIES.map(p => [p.customerId, p]));

// ---------------------------------------------------------------------------
// Orders (30 records)
// ---------------------------------------------------------------------------
export const SCHEMES = [null, "10+1 Free", "5% Cash Discount", "Buy 2 Get 1", null, null];

// Phase 5: net-value multiplier per scheme, reused by the Order Booking form
// so the live total shown while booking matches how each scheme actually works.
export const SCHEME_DISCOUNT_MULTIPLIER = {
  "10+1 Free": 10 / 11,       // pay for 10, receive 11 — ~9.1% effective discount
  "5% Cash Discount": 0.95,
  "Buy 2 Get 1": 2 / 3,       // pay for 2, receive 3 — ~33.3% effective discount
};
export function getSchemeMultiplier(scheme) {
  return SCHEME_DISCOUNT_MULTIPLIER[scheme] ?? 1;
}

// FIX #10 (believability): real distributor order books are power-law, not
// flat. Instead of hand-writing a 120-entry array, per-pharmacy order counts
// are declared as weights and expanded. 2 anchor accounts carry ~27% of
// volume, a long tail gets 2-3 each, and 2 pharmacies place none — instead
// of the original i % 22 round-robin, which gave every pharmacy an identical
// 1-2 orders and read as obviously synthetic in the Pharmacy Sales Report.
const ORDER_WEIGHTS = [18, 3, 4, 14, 2, 6, 5, 10, 2, 7, 3, 8, 2, 5, 3, 9, 2, 6, 3, 8, 0, 0]; // sums to 120

// P0 (BRD M8 prerequisite): 12 months of order history. The previous 2-month
// window (2026-06, 2026-07) made BRD Module 8's "Quarterly Purchase Value"
// and "Annual Purchase Value" impossible to derive honestly — any such figure
// would have been fabricated rather than computed. 120 orders across 12
// months gives ~10/month, enough for real period-over-period analysis.
const MONTH_SEQUENCE = [
  "2025-08", "2025-09", "2025-10", "2025-11", "2025-12", "2026-01",
  "2026-02", "2026-03", "2026-04", "2026-05", "2026-06", "2026-07",
];
const ORDERS_PER_MONTH = 10;
const TOTAL_ORDERS = MONTH_SEQUENCE.length * ORDERS_PER_MONTH; // 120

// Orders in the trailing 2 months are the "in-flight" window — anything older
// has necessarily completed its lifecycle. Without this, a 10-month-old order
// could sit at "Telecaller Validation" forever, which no reviewer would find
// credible.
const IN_FLIGHT_FROM_INDEX = (MONTH_SEQUENCE.length - 2) * ORDERS_PER_MONTH; // 100

// Expanding the weights above in sequence would cluster each pharmacy's
// orders into consecutive indices — and since the order date is derived from
// index, one pharmacy's entire year would land in a single month. A stride
// coprime with the pool length visits every slot exactly once, spreading each
// pharmacy's orders across the whole window deterministically.
const ORDER_PHARMACY_ASSIGNMENT = (() => {
  const pool = [];
  ORDER_WEIGHTS.forEach((weight, phIdx) => { for (let k = 0; k < weight; k++) pool.push(phIdx); });
  const out = [];
  const stride = 7; // gcd(7, 120) === 1
  for (let k = 0, j = 0; k < pool.length; k++) { out.push(pool[j]); j = (j + stride) % pool.length; }
  return out;
})();

// FIX #11 + #13, merged and made roll-proof.
//
// #13: the stage-roll formula below never produces a stage earlier than
// "Warehouse Processing" (floor(rnd()*8)+3 has a floor of index 3), so the
// Pharmacy OTP, Telecaller Validation and Stock Allocation role desks had no
// baseline orders to act on.
//
// #11: a report named "Delayed Orders Report" showing zero rows on open reads
// as broken rather than correct, so the steady baseline needs genuine
// minor-delay (Yellow) orders — ordinary processing friction, unrelated to
// the Supply Disruption scenario's forex/import narrative.
//
// Both were previously separate maps, and the Yellow one keyed only a traffic
// light while leaving the stage to the dice. When a seeded index happened to
// roll "Delivered", the Delivered-implies-Green rule silently cancelled the
// seed and the Delayed Orders Report went empty again. Pinning stage AND
// light together in one map removes that dependency entirely.
//
// All six indices sit in the in-flight window and avoid disrupted SKUs
// (i % PRODUCTS.length), so they stay reachable in every scenario.
const IN_FLIGHT_SEED = {
  102: { stageIdx: 0 },                   // Order Received       — Pharmacy OTP desk
  105: { stageIdx: 1 },                   // Telecaller Validation — Telecaller desk
  108: { stageIdx: 2 },                   // Stock Allocation      — Warehouse desk
  100: { stageIdx: 3, light: "Yellow" },  // Warehouse Processing  — minor delay
  106: { stageIdx: 4, light: "Yellow" },  // Dispatch Pending      — minor delay
  113: { stageIdx: 5, light: "Yellow" },  // Dispatched            — minor delay
};

export const ORDERS = Array.from({ length: TOTAL_ORDERS }).map((_, i) => {
  const pharmacy = PHARMACIES[ORDER_PHARMACY_ASSIGNMENT[i]];
  const product = PRODUCTS[i % PRODUCTS.length];
  const isDisruptedOrder = DISRUPTED_SKUS.includes(product.sku);
  const isInFlight = i >= IN_FLIGHT_FROM_INDEX;
  const qty = 20 + Math.floor(rnd() * 180);
  const unitPrice = 3 + rnd() * 22;
  const orderValue = Math.round(qty * unitPrice * 100) / 100;

  const orderMonth = MONTH_SEQUENCE[Math.min(MONTH_SEQUENCE.length - 1, Math.floor(i / ORDERS_PER_MONTH))];
  const orderYear = orderMonth.slice(0, 4);
  const dayOfMonth = 1 + (i % 27);
  const orderDate = `${orderMonth}-${String(dayOfMonth).padStart(2, "0")}`;
  const deliveryDay = Math.min(28, dayOfMonth + 5);
  const expectedDeliveryDate = `${orderMonth}-${String(deliveryDay).padStart(2, "0")}`;

  // rnd() is called unconditionally to keep the PRNG sequence stable
  // regardless of which branch the stage decision takes.
  const rolledStageIdx = Math.min(STAGES.length - 1, Math.floor(rnd() * STAGES.length) + 3);
  const seed = IN_FLIGHT_SEED[i];
  let baseStageIdx;
  if (seed) baseStageIdx = seed.stageIdx;
  else if (!isInFlight) baseStageIdx = STAGES.length - 1; // historical orders are Delivered
  else baseStageIdx = rolledStageIdx;

  const baseLight = STAGES[baseStageIdx] === "Delivered" ? "Green" : (seed?.light || "Green");

  return {
    orderNo: `ORD-${orderYear}-${String(i + 1).padStart(5, "0")}`,
    customerId: pharmacy.customerId,
    orderDate,
    productSku: product.sku, // FIX #2: sku only; productName resolved via join in getter
    quantity: qty,
    schemeApplied: SCHEMES[i % SCHEMES.length],
    orderValue,
    expectedDeliveryDate,
    baseline: {
      currentStage: STAGES[baseStageIdx],
      trafficLight: baseLight,
      tatDays: 2 + Math.floor(rnd() * 3)
    },
    scenarioOverrides: {
      // A supply disruption stalls orders currently moving through the
      // pipeline; it cannot retroactively un-deliver an order from last year.
      disruption: (isDisruptedOrder && isInFlight) ? {
        currentStage: rnd() > 0.5 ? "Dispatch Pending" : "Warehouse Processing",
        trafficLight: rnd() > 0.4 ? "Red" : "Orange",
        tatDays: 12 + Math.floor(rnd() * 10)
      } : null,
      growth: pharmacy.growthCohort ? {
        orderValue: Math.round(orderValue * 1.35 * 100) / 100,
        quantity: Math.round(qty * 1.3)
      } : null
    }
  };
});

// ---------------------------------------------------------------------------
// Stock Records (16 SKUs x 2-3 warehouses = 40 rows)
// ---------------------------------------------------------------------------
const IMPACTED_POOL = PHARMACIES.slice(0, 10).map(p => p.customerId);

export const STOCK_RECORDS = [];
PRODUCTS.forEach((product, pi) => {
  const whCount = 2 + (pi % 2);
  for (let w = 0; w < whCount; w++) {
    const warehouse = WAREHOUSES[w % WAREHOUSES.length];
    const isDisruptedHere = product.isDisrupted && w === 0;
    const reservedQty = 10 + Math.floor(rnd() * 60);
    const availableQty = 80 + Math.floor(rnd() * 400);
    // FIX #9: steady-state low-stock flag lives on data, so notification is
    // derivable rather than hardcoded; baseline stays clean (no OOS).
    const lowStock = !isDisruptedHere && availableQty < 140;

    STOCK_RECORDS.push({
      productSku: product.sku,
      warehouse,
      batchNo: `B${product.sku.slice(4)}${w}26`,
      mfgDate: "2025-11-01",
      expiryDate: "2027-11-01",
      baseline: {
        availableQty: isDisruptedHere ? 60 + Math.floor(rnd() * 40) : availableQty,
        reservedQty,
        inTransitQty: 10 + Math.floor(rnd() * 30),
        replenishmentDate: null,
        oosStatus: false,
        oosDate: null,
        oosDuration: null,
        impactedPharmacies: [],
        delayReasonCode: null,
        delayRemarks: null,
        lowStock
      },
      scenarioOverrides: {
        disruption: isDisruptedHere ? {
          availableQty: 0,
          reservedQty,
          inTransitQty: 0,
          replenishmentDate: "2026-09-15",
          oosStatus: true,
          oosDate: "2026-07-10",
          oosDuration: 18,
          impactedPharmacies: IMPACTED_POOL.slice(pi % 5, (pi % 5) + 4),
          delayReasonCode: pi % 4 === 3 ? "Logistics/Transport Delay" : "Forex/Import Delay",
          delayRemarks: pi % 4 === 3
            ? "Shipment held at Beitbridge border post pending customs clearance."
            : "Supplier PO placed 22-May-2026; payment unpaid pending forex allocation via RBZ auction. Release awaiting forex tranche.",
          lowStock: false
        } : null,
        growth: product.sku === PROMOTED_SKU ? {
          reservedQty: Math.round(reservedQty * 1.6)
        } : null
      }
    });
  }
});

// ---------------------------------------------------------------------------
// POB Records (8 territories x 6 trailing months = 48 rows)
// FIX #8: each record now carries productWiseBreakdown (BRD Module 9 "Product-wise POB").
// ---------------------------------------------------------------------------
const MONTHS = ["2026-02", "2026-03", "2026-04", "2026-05", "2026-06", "2026-07"];
const DISRUPTION_TERRITORIES = ["Manicaland", "Midlands"];
const GROWTH_TERRITORIES = ["Harare", "Mashonaland East"];
const POB_DIVISIONS = ["Antibiotics", "Cardiac", "Diabetes", "Pain Management", "Vitamins"];

function splitByDivision(total) {
  // deterministic-ish split across 5 divisions summing to total
  const weights = [0.28, 0.24, 0.2, 0.16, 0.12];
  return POB_DIVISIONS.map((d, i) => ({
    division: d,
    value: Math.round(total * weights[i])
  }));
}

export const POB_RECORDS = [];
TERRITORIES.forEach((territory, ti) => {
  MONTHS.forEach((month, mi) => {
    const targetValue = 40000 + ti * 3000 + mi * 500;
    // FIX #12 (believability): the old formula (95 + rnd()*11 => 95-105 for
    // EVERY territory) meant steady-state had no real laggard or standout —
    // every territory clustered in a suspiciously tight 9-10pt band. Real
    // regional performance always has spread. Matabeleland South is seeded
    // as a genuine rural-coverage-gap underperformer (this is also the
    // territory Market Research already flags as a "coverage gap" — the two
    // modules now agree with each other instead of one being unbacked flavor
    // text). Mashonaland West is seeded as a standout. Neither territory is
    // otherwise used by the disruption/growth scenario overrides below, so
    // there's no conflict when switching scenarios.
    let baseAchievePct;
    if (territory === "Matabeleland South") {
      baseAchievePct = 78 + Math.floor(rnd() * 7); // 78-84: rural coverage-gap laggard
    } else if (territory === "Mashonaland West") {
      baseAchievePct = 108 + Math.floor(rnd() * 7); // 108-114: standout
    } else {
      baseAchievePct = 95 + Math.floor(rnd() * 11); // 95-105: on-target band
    }
    const achievedValue = Math.round(targetValue * (baseAchievePct / 100));

    let disruptionOverride = null;
    if (DISRUPTION_TERRITORIES.includes(territory) && mi >= 4) {
      const pct = 68 + Math.floor(rnd() * 12);
      const av = Math.round(targetValue * (pct / 100));
      disruptionOverride = { targetValue, achievedValue: av, achievementPct: pct, productWiseBreakdown: splitByDivision(av) };
    }
    let growthOverride = null;
    if (GROWTH_TERRITORIES.includes(territory)) {
      const pct = 108 + mi * 2 + Math.floor(rnd() * 6);
      const av = Math.round(targetValue * (pct / 100));
      growthOverride = { targetValue, achievedValue: av, achievementPct: pct, productWiseBreakdown: splitByDivision(av) };
    }

    POB_RECORDS.push({
      territory,
      month,
      baseline: { targetValue, achievedValue, achievementPct: baseAchievePct, productWiseBreakdown: splitByDivision(achievedValue) },
      scenarioOverrides: { disruption: disruptionOverride, growth: growthOverride }
    });
  });
});

// ---------------------------------------------------------------------------
// Brand Performance (FIX #6: dedicated aggregate, 16 brands, not derived from
// 30 sparse orders). MoM growth + revenue contribution per BRD Module 12.
// ---------------------------------------------------------------------------
export const BRAND_PERFORMANCE = PRODUCTS.map((p, i) => {
  const baseRevenue = 12000 + Math.floor(rnd() * 60000);
  const baseGrowth = -8 + Math.floor(rnd() * 26); // -8%..+18%
  const disrupted = p.isDisrupted;
  const promoted = p.isPromoted;
  // 6-month revenue series for MoM trend
  const mkSeries = (start, trendPct) => {
    const s = [];
    let v = start;
    for (let m = 0; m < 6; m++) { s.push(Math.round(v)); v = v * (1 + trendPct / 100); }
    return s;
  };
  return {
    sku: p.sku,
    brandName: p.brandName,
    division: p.division,
    baseline: {
      revenue: baseRevenue,
      momGrowthPct: baseGrowth,
      revenueSeries: mkSeries(baseRevenue / 6, baseGrowth / 3),
      movement: baseGrowth > 6 ? "Fast" : baseGrowth < -2 ? "Slow" : "Steady"
    },
    scenarioOverrides: {
      disruption: disrupted ? {
        revenue: Math.round(baseRevenue * 0.55),
        momGrowthPct: -22 - Math.floor(rnd() * 12),
        revenueSeries: mkSeries(baseRevenue / 6, -18),
        movement: "Slow"
      } : null,
      growth: promoted ? {
        revenue: Math.round(baseRevenue * 1.7),
        momGrowthPct: 34 + Math.floor(rnd() * 10),
        revenueSeries: mkSeries(baseRevenue / 6, 22),
        movement: "Fast"
      } : null
    }
  };
});

// ---------------------------------------------------------------------------
// Campaigns (4 records)
// ---------------------------------------------------------------------------
export const CAMPAIGNS = [
  {
    campaignName: "Cardiopril Heart Health Drive",
    productSku: "HET-2001",
    startDate: "2026-05-01",
    endDate: "2026-07-31",
    baseline: {
      reach: 8400, effectivenessScore: 62, adoptionRate: 18,
      territoryPerformance: TERRITORIES.map(t => ({ territory: t, performanceScore: 55 + Math.floor(rnd() * 20) }))
    },
    scenarioOverrides: {
      growth: {
        reach: 14200, effectivenessScore: 84, adoptionRate: 39,
        territoryPerformance: TERRITORIES.map(t => ({ territory: t, performanceScore: (t === "Harare" || t === "Mashonaland East") ? 88 + Math.floor(rnd() * 8) : 60 + Math.floor(rnd() * 15) }))
      },
      disruption: null
    },
    scenarioNote: {
      growth: "Centerpiece campaign — reach and adoption climbed sharply, directly correlated with Cardiopril order volume in Harare and Mashonaland East.",
      disruption: null
    }
  },
  {
    campaignName: "Insulet Diabetes Awareness Month",
    productSku: "HET-3002",
    startDate: "2026-06-01",
    endDate: "2026-07-15",
    baseline: {
      reach: 5200, effectivenessScore: 58, adoptionRate: 21,
      territoryPerformance: TERRITORIES.map(t => ({ territory: t, performanceScore: 45 + Math.floor(rnd() * 25) }))
    },
    scenarioOverrides: { growth: null, disruption: null },
    scenarioNote: {
      growth: null,
      disruption: "Adoption interest is outpacing fulfillment — pharmacies report rising patient enquiries for Insulet while the SKU is OOS at Harare Central."
    }
  },
  {
    campaignName: "Vitahet C Immunity Season",
    productSku: "HET-5001",
    startDate: "2026-04-15",
    endDate: "2026-06-30",
    baseline: {
      reach: 6100, effectivenessScore: 54, adoptionRate: 15,
      territoryPerformance: TERRITORIES.map(t => ({ territory: t, performanceScore: 40 + Math.floor(rnd() * 20) }))
    },
    scenarioOverrides: { growth: null, disruption: null },
    scenarioNote: { growth: null, disruption: null }
  },
  {
    campaignName: "Painex-Het Rapid Relief Push",
    productSku: "HET-4001",
    startDate: "2026-03-01",
    endDate: "2026-05-15",
    baseline: {
      reach: 4700, effectivenessScore: 49, adoptionRate: 12,
      territoryPerformance: TERRITORIES.map(t => ({ territory: t, performanceScore: 38 + Math.floor(rnd() * 22) }))
    },
    scenarioOverrides: { growth: null, disruption: null },
    scenarioNote: { growth: null, disruption: null }
  }
];

// ---------------------------------------------------------------------------
// Notifications — FIX #9: steady-state low-stock notification removed from "all";
// low-stock alerts are now derived from stock data at render time. Only genuinely
// cross-scenario events stay "all".
// ---------------------------------------------------------------------------
export const NOTIFICATIONS = [
  // P0: every order number shifted when history was extended to 12 months, so
  // these references were repointed. Each now targets an in-flight order whose
  // ACTUAL state matches the message — a "dispatched" alert resolves to a
  // Dispatched order, a "payment due" alert to a Payment Pending invoice — so
  // clicking through never lands on a contradictory record.
  { id: "N-001", type: "Order", message: "Order ORD-2026-00103 submitted", channel: "Push", timestamp: "2026-07-24 09:12", relatedEntityId: "ORD-2026-00103", scenario: "all" },
  { id: "N-002", type: "Order", message: "Order ORD-2026-00109 approved by Telecaller", channel: "SMS", timestamp: "2026-07-24 10:03", relatedEntityId: "ORD-2026-00109", scenario: "all" },
  { id: "N-004", type: "Stock", message: "OOS Alert — Hetrocef 500 at Harare Central", channel: "Push", timestamp: "2026-07-10 08:00", relatedEntityId: "HET-1001", scenario: "disruption" },
  { id: "N-005", type: "Stock", message: "Escalation: Insulet Mix 30/70 OOS exceeds 14 days", channel: "Email", timestamp: "2026-07-24 07:30", relatedEntityId: "HET-3002", scenario: "disruption" },
  { id: "N-006", type: "Stock", message: "Replenishment notification — Atorstat 20 expected 15-Sep-2026", channel: "SMS", timestamp: "2026-07-22 14:15", relatedEntityId: "HET-2003", scenario: "disruption" },
  { id: "N-007", type: "Invoice", message: "Invoice INV-88103 generated", channel: "Email", timestamp: "2026-07-24 11:20", relatedEntityId: "ORD-2026-00104", scenario: "all" },
  { id: "N-008", type: "Invoice", message: "Payment due reminder — INV-88091", channel: "SMS", timestamp: "2026-07-23 09:00", relatedEntityId: "ORD-2026-00092", scenario: "all" },
  { id: "N-009", type: "Order", message: "Order ORD-2026-00114 dispatched", channel: "Push", timestamp: "2026-07-24 13:45", relatedEntityId: "ORD-2026-00114", scenario: "growth" },
  { id: "N-010", type: "Order", message: "Order ORD-2026-00110 delivered", channel: "SMS", timestamp: "2026-07-24 15:02", relatedEntityId: "ORD-2026-00110", scenario: "growth" },
  { id: "N-011", type: "Stock", message: "Reserved quantity rising — Cardiopril 10 demand up 60% this month", channel: "Email", timestamp: "2026-07-20 10:10", relatedEntityId: "HET-2001", scenario: "growth" },
  // Covers the BRD's "Order Rejected" event type without asserting a false
  // current state: this order was rejected, resubmitted, and is now moving
  // again — which also explains why it carries a Yellow minor-delay flag.
  { id: "N-012", type: "Order", message: "Order ORD-2026-00101 rejected by Telecaller — resubmitted, now reprocessing", channel: "Push", timestamp: "2026-07-21 11:55", relatedEntityId: "ORD-2026-00101", scenario: "steady" }
];

// ---------------------------------------------------------------------------
// Invoices (BRD Module 7 — Invoice & Billing Tracking)
// Derived from orders: an order that has reached "Invoice Generated" or
// "Delivered" has an invoice. Billing stage + payment state are scenario-aware:
//  - disruption: invoicing/payment stalls on the affected (Red/Orange) orders
//  - growth: growth-cohort orders clear to "Payment Received" faster
// ---------------------------------------------------------------------------
// B1 (BRD deviation resolution): BRD §4.1 assigns "Update payment status" to
// Pharmacy User. The original build blocked pharmacies from marking payment
// received at all, reasoning that a payer shouldn't self-certify receipt —
// defensible for internal controls, but it contradicted the BRD as written.
// Split into two real stages: the pharmacy can report a payment was made
// (with a reference), and Finance/Admin independently confirms it landed —
// which satisfies §4.1 literally while keeping the confirmation authoritative
// with Finance, matching how real receivables reconciliation works.
const BILLING_STAGES = ["Order Confirmed", "Invoice Pending", "Invoice Generated", "Payment Pending", "Payment Reported", "Payment Received"];
const TAX_RATE = 0.15; // Zimbabwe VAT 15%
// Deliveries before this date are treated as collected (see buildInvoices).
const RECEIVABLES_SETTLED_BEFORE = "2026-05-01";

function buildInvoices(scenario) {
  const orders = getOrders(scenario);
  const invoices = [];
  orders.forEach((o, i) => {
    const stageIdx = STAGES.indexOf(o.currentStage);
    const invoicedStageIdx = STAGES.indexOf("Invoice Generated");
    // Only orders at/after Invoice Generated (or Delivered) have a real invoice;
    // earlier orders sit in pre-invoice billing states.
    const hasInvoice = stageIdx >= invoicedStageIdx;

    let billingStage;
    if (o.trafficLight === "Red" || o.trafficLight === "Orange") {
      // disrupted orders stall before/around invoicing
      billingStage = stageIdx >= invoicedStageIdx ? "Payment Pending" : "Invoice Pending";
    } else if (o.currentStage === "Delivered") {
      // P0: with 12 months of history, an aged delivery still showing as
      // unpaid is not credible — real receivables age out. Deliveries older
      // than roughly a quarter are settled; only recent ones stay mixed, so
      // the outstanding-receivable figure reflects current business rather
      // than a year of uncollected debt.
      const ph = PHARMACY_BY_ID[o.customerId];
      if (o.orderDate < RECEIVABLES_SETTLED_BEFORE) {
        billingStage = "Payment Received";
      } else {
        billingStage = (scenario === "growth" && ph && ph.growthCohort) ? "Payment Received"
                      : (i % 3 === 0 ? "Payment Received" : "Payment Pending");
      }
    } else if (hasInvoice) {
      billingStage = "Invoice Generated";
    } else if (stageIdx >= STAGES.indexOf("Telecaller Validation")) {
      billingStage = "Order Confirmed";
    } else {
      billingStage = "Order Confirmed";
    }

    const taxAmount = Math.round(o.orderValue * TAX_RATE * 100) / 100;
    const invoiceValue = Math.round((o.orderValue + taxAmount) * 100) / 100;

    invoices.push({
      invoiceNo: hasInvoice ? `INV-${88000 + i}` : null,
      orderNo: o.orderNo,
      customerId: o.customerId,
      pharmacyName: o.pharmacyName,
      productName: o.productName,
      invoiceDate: hasInvoice ? o.expectedDeliveryDate : null,
      baseValue: o.orderValue,
      taxAmount,
      invoiceValue,
      billingStage,
      trafficLight: o.trafficLight,
    });
  });
  return invoices;
}

export function getInvoices(scenario) { return buildInvoices(scenario); }
export const BILLING_STAGE_LIST = BILLING_STAGES;

export const SCENARIO_SUMMARIES = {
  steady: {
    label: "Steady-State Growth",
    text: "Normal operating conditions. Orders flowing on schedule, stock levels healthy, POB tracking close to target across all territories."
  },
  disruption: {
    label: "Supply Disruption",
    text: "4 SKUs OOS following a forex-driven import delay and a border logistics hold. Order TAT rising in Manicaland and Midlands; 2 territories below POB target."
  },
  growth: {
    label: "High-Growth Territory",
    text: "6 pharmacies onboarded and upgraded in Harare & Mashonaland East. Cardiopril campaign driving order volume; those 2 territories are over-achieving POB target."
  }
};

// ---------------------------------------------------------------------------
// Getters — the ONLY interface UI components should use.
// FIX #5: explicit per-scenario field application, no key-presence probing.
// FIX #2: productName/brandName joined in here so components never see undefined.
// ---------------------------------------------------------------------------
function enrichProduct(sku) {
  const p = PRODUCT_BY_SKU[sku] || {};
  return { productName: p.productName || sku, brandName: p.brandName || "", division: p.division || "" };
}

export function getPharmacies(scenario) {
  return PHARMACIES.map(p => {
    const o = scenario === "growth" ? p.scenarioOverrides.growth : null;
    return o ? { ...p, ...o } : { ...p };
  });
}

export function getProducts() { return PRODUCTS.map(p => ({ ...p })); }

export function getOrders(scenario) {
  return ORDERS.map(o => {
    const ov = o.scenarioOverrides[scenario] || null;
    const prod = enrichProduct(o.productSku);
    const base = {
      orderNo: o.orderNo,
      customerId: o.customerId,
      pharmacyName: (PHARMACY_BY_ID[o.customerId] || {}).pharmacyName || o.customerId,
      orderDate: o.orderDate,
      productSku: o.productSku,
      productName: prod.productName,
      brandName: prod.brandName,
      quantity: o.quantity,
      schemeApplied: o.schemeApplied,
      orderValue: o.orderValue,
      expectedDeliveryDate: o.expectedDeliveryDate,
      currentStage: o.baseline.currentStage,
      trafficLight: o.baseline.trafficLight,
      tatDays: o.baseline.tatDays
    };
    if (!ov) return base;
    if (scenario === "disruption") {
      return { ...base, currentStage: ov.currentStage, trafficLight: ov.trafficLight, tatDays: ov.tatDays };
    }
    if (scenario === "growth") {
      return { ...base, orderValue: ov.orderValue, quantity: ov.quantity };
    }
    return base;
  });
}

export function getStock(scenario) {
  return STOCK_RECORDS.map(s => {
    const ov = s.scenarioOverrides[scenario] || null;
    const prod = enrichProduct(s.productSku);
    const merged = ov ? { ...s.baseline, ...ov } : { ...s.baseline };
    return {
      productSku: s.productSku,
      productName: prod.productName,
      brandName: prod.brandName,
      warehouse: s.warehouse,
      batchNo: s.batchNo,
      mfgDate: s.mfgDate,
      expiryDate: s.expiryDate,
      ...merged
    };
  });
}

export function getPOB(scenario) {
  return POB_RECORDS.map(r => {
    const ov = r.scenarioOverrides[scenario] || null;
    return { territory: r.territory, month: r.month, ...(ov ? { ...r.baseline, ...ov } : { ...r.baseline }) };
  });
}

export function getBrandPerformance(scenario) {
  return BRAND_PERFORMANCE.map(b => {
    const ov = b.scenarioOverrides[scenario] || null;
    return { sku: b.sku, brandName: b.brandName, division: b.division, ...(ov ? { ...b.baseline, ...ov } : { ...b.baseline }) };
  });
}

export function getCampaigns(scenario) {
  return CAMPAIGNS.map(c => {
    const ov = c.scenarioOverrides[scenario] || null;
    const base = ov ? { ...c.baseline, ...ov } : { ...c.baseline };
    return {
      campaignName: c.campaignName,
      productSku: c.productSku,
      productName: enrichProduct(c.productSku).productName,
      startDate: c.startDate,
      endDate: c.endDate,
      ...base,
      scenarioNote: c.scenarioNote[scenario] || null
    };
  });
}

export function getNotifications(scenario) {
  // FIX #9: derive low-stock notifications from stock data instead of hardcoding.
  const derived = [];
  if (scenario === "steady" || scenario === "all") {
    getStock(scenario).filter(s => s.lowStock).slice(0, 3).forEach((s, i) => {
      derived.push({
        id: `N-LS-${i}`, type: "Stock",
        message: `Low stock alert — ${s.productName} at ${s.warehouse}`,
        channel: "Email", timestamp: "2026-07-23 16:40",
        relatedEntityId: s.productSku, scenario: "steady"
      });
    });
  }
  const base = NOTIFICATIONS.filter(n => n.scenario === "all" || n.scenario === scenario);
  return [...base, ...derived];
}

export function getScenarioSummary(scenario) { return SCENARIO_SUMMARIES[scenario]; }

// ---------------------------------------------------------------------------
// Scenario relevance per pharmacy (issue #5): not every clinic's data actually
// differs across steady/disruption/growth. Growth only touches the 6-pharmacy
// growth cohort; disruption only touches pharmacies listed as impacted by an
// OOS SKU. This lets the UI say so honestly instead of presenting all three
// scenarios as equally meaningful for every clinic.
export function isScenarioRelevantToPharmacy(scenario, customerId) {
  if (scenario === 'steady') return true; // baseline always "applies"
  if (scenario === 'growth') {
    const p = PHARMACIES.find(ph => ph.customerId === customerId);
    return !!(p && p.growthCohort);
  }
  if (scenario === 'disruption') {
    return STOCK_RECORDS.some(r =>
      r.scenarioOverrides.disruption &&
      r.scenarioOverrides.disruption.impactedPharmacies &&
      r.scenarioOverrides.disruption.impactedPharmacies.includes(customerId)
    );
  }
  return true;
}

// ---------------------------------------------------------------------------
// Pharmacy-scoped getters — used by the Pharmacy User role so every screen
// shows ONLY that clinic's data, never the aggregate across all pharmacies.
// ---------------------------------------------------------------------------
export function getOrdersForPharmacy(scenario, customerId) {
  return getOrders(scenario).filter(o => o.customerId === customerId);
}

export function getInvoicesForPharmacy(scenario, customerId) {
  return getInvoices(scenario).filter(i => i.customerId === customerId);
}

export function getCampaignsForPharmacy(scenario, customerId) {
  const myOrders = getOrdersForPharmacy(scenario, customerId);
  const myProductSkus = new Set(myOrders.map(o => o.productSku));
  const pharmacy = PHARMACIES.find(p => p.customerId === customerId);
  const myTerritory = pharmacy ? pharmacy.territory : null;

  return getCampaigns(scenario).map(c => {
    const orderedThisProduct = myProductSkus.has(c.productSku);
    const territoryPerf = c.territoryPerformance.find(t => t.territory === myTerritory);
    return {
      ...c,
      orderedThisProduct,
      territoryRelevanceScore: territoryPerf ? territoryPerf.performanceScore : null,
      relevanceNote: orderedThisProduct
        ? `You've ordered ${c.productName} — this promotion applies directly to you.`
        : `New to you: ${c.productName} is featured in this campaign, active in your territory (${myTerritory}).`
    };
  });
}